/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useUser} from '../../../modules/newauth/UserContext'
const SendCommandTab = ({deviceData}) => {
  const {user} = useUser()

  const [message, setMessage] = useState('')

  const handleSendCommand = async () => {
    console.log('Send command:', message)
    console.log('deviceData:', deviceData)
    console.log('Device Type:', deviceData.type)

    if (!deviceData.type) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Device Type is not defined!',
      })
      return
    } else {
      const payload = {
        deviceId: deviceData.device_id,
        deviceType: deviceData.type,
        command: message,
      }
      const apiUrl = `https://apiadminv2-osyebuvkwa-as.a.run.app/v1/devices/send-command`

      //  รอเครื่อง Stellar มาทดสอบ

      // try {
      //   const response = await axios.post(apiUrl, payload, {
      //     headers: {
      //       Authorization: `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjAzZDA3YmJjM2Q3NWM2OTQyNzUxMGY2MTc0ZWIyZjE2NTQ3ZDRhN2QiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZHlnaXN0ZWNocGxhdGZvcm0iLCJhdWQiOiJkeWdpc3RlY2hwbGF0Zm9ybSIsImF1dGhfdGltZSI6MTY5Nzc4NTcyMiwidXNlcl9pZCI6IjBjdEdHbkluMXZRV1ByZ1dPZDM1T1NWVWlyMTIiLCJzdWIiOiIwY3RHR25JbjF2UVdQcmdXT2QzNU9TVlVpcjEyIiwiaWF0IjoxNjk3Nzg1NzIzLCJleHAiOjE2OTc3ODkzMjMsImVtYWlsIjoic2VydmljZUBkeWdpc3RlY2guY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsic2VydmljZUBkeWdpc3RlY2guY29tIl19LCJzaWduX2luX3Byb3ZpZGVyIjoicGFzc3dvcmQifX0.aQznyxNcaNjjRMJVQj5LONf3NCz-hM2ICikrKuUK_65tO2yr4Bq4-Y918rDGNsSBqcjRhM5JKhgYdjgpVv_hXdr2fRCp5deyezP76jzAecRZYFKyKpwSt0_mokXHA3EmYZQdrVwpGxdgN4ObU30_Z2nx0qSuEMDQt8dlviaWfVT98F1oLVW6Y2Adi8n958bDprAYsW1Q_QRFc7QnW1HpqokJCQIqWQqPl3VBkQiXYSvt9rmpLcEnUm6LvSNX4nO5Rvo5zFehLG7fHhK4yeEES4hKzWW9DUxjNMbCvqXeaCEQy-lKCo-ZbNUWG7lZaVIyVXiQ08-PJDsae3sr6B1NpA`,
      //     },
      //   })
      //   console.log(response)
      //   // Swal.fire({
      //   //   icon: 'success',
      //   //   title: 'Rename status parameter successfully!',
      //   // }).then(() => {
      //   // })
      // } catch (error) {
      //   console.error('Error fetching data:', error)
      //   // Swal.fire({
      //   //   icon: 'error',
      //   //   title: 'Oops...',
      //   //   text: 'Something went wrong!',
      //   // })
      // }
    }
  }

  return (
    <>
      <div className='mb-5 mt-5'>
        <p className='mb-3 fw-bold fs-3'>Send Command : </p>

        <div className='mb-3'>
          <div
            class='btn btn-outline btn-outline-dashed btn-outline-default me-3'
            onClick={() => setMessage('{"cmd": "set_device_name", "cmd_id": "xxxxx", "value": ""}')}
          >
            Device Name
          </div>
          <div
            class='btn btn-outline btn-outline-dashed btn-outline-default me-3'
            onClick={() =>
              setMessage(
                '{"cmd": "set_lim", "data": {"params":"","min": "","max" : ""}, "cmd_id": ""}'
              )
            }
          >
            Limit
          </div>
          <div
            class='btn btn-outline btn-outline-dashed btn-outline-default me-3'
            onClick={() => setMessage('{"cmd": "set_interval", "cmd_id": "xxxxx", "value": ""}')}
          >
            Interval
          </div>
        </div>

        <textarea
          className='form-control mb-5'
          rows={5}
          placeholder='Type a message'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>

        <div className='btn btn-secondary me-5' onClick={() => setMessage('')}>
          Clear
        </div>

        <div className='btn btn-primary disabled' onClick={() => handleSendCommand()}>
          Send
        </div>
      </div>
    </>
  )
}

export {SendCommandTab}
